<template>
	<div class="mdView">
		<!-- <div v-html="renderedMarkdown"></div> -->
		<vue-markdown :source="markdownContent" />
	</div>
</template>

<script>
// import MarkdownIt from "markdown-it";
import VueMarkdown from 'vue-markdown';
import '../../../../common/aws-sdk-2.235.1.min.js'

const getFile = (url) => {
	return new Promise((resolve, reject) => {
		var credentials = {
			accessKeyId: "AKIATLPEDU37QV5CHLMH",
			secretAccessKey: "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",
		}; //秘钥形式的登录上传
		window.AWS.config.update(credentials);
		window.AWS.config.region = "cn-northwest-1"; //设置区域
		let url2 = url;
		let _url2 = "";
		if (
			url2.indexOf("https://view.officeapps.live.com/op/view.aspx?src=") != -1
		) {
			_url2 = url2.split(
				"https://view.officeapps.live.com/op/view.aspx?src="
			)[1];
		} else {
			_url2 = url2;
		}
		var s3 = new window.AWS.S3({ params: { Bucket: "ccrb" } });
		let name = decodeURIComponent(
			_url2.split("https://ccrb.s3.cn-northwest-1.amazonaws.com.cn/")[1]
		);
		var params = {
			Bucket: "ccrb",
			Key: name,
		};
		s3.getObject(params, function (err, data) {
			if (err) {
				console.log(err, err.stack);
				resolve({ data: 1 });
			} else {
				const fileContent = data.Body.toString('utf-8');
				resolve({ data: fileContent });
			} // sxuccessful response
		});
		// axios({
	});
};
export default {
	components: {
		VueMarkdown,
	},
	props: {
		url: {
			type: String,
			default: "",
		},
		text:{
			type:String,
			default:"",
		},
	},
	data() {
		return {
			markdownContent: "",
		};
	},
	watch:{
		text(){
			this.markdownContent = this.text;
		}
	},
	// computed: {
	// 	renderedMarkdown() {
	// 		return this.md.render(this.markdownContent);
	// 	},
	// },
	methods: {
		getMarkdown() {
			if(this.text)return this.markdownContent = this.text;
			if(!this.url)return;
			getFile(this.url).then(res=>{
				this.markdownContent = res.data;
			})
		},
	},
	mounted(){
		this.getMarkdown();
	}
};
</script>
<style scoped>
.mdView {
	max-width: 100%;
	height: 100%;
}

.mdView >>>.table{
	width: 100%;
  border-collapse: collapse;
	margin: 10px 0;
}

.mdView >>>th,td{
    border: 1px solid #999;
    text-align: center;
    padding: 10px 10px;
}
.mdView >>>td{
    border: 1px solid #999;
    text-align: center;
    padding: 10px 10px;
}

.mdView>>>ol{
	margin-left: 20px;
}

.mdView>>>ul{
	margin-left: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/classroomObservation/components/mdView.vue